import React, { useEffect, useState } from 'react';
import { EllipsisOutlined } from '@ant-design/icons';
import appconstant from '../../themes/appconstant';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { adminInnerCircleDetailLoad } from '../../redux/slices/adminInner.slice';
import { imageURL } from '../../redux/Api/apikit';

const SERVER_URL = imageURL

const InnerFeedCard = ({ id, myid }) => {

  const dispatch = useDispatch();
  const [showAllImages, setShowAllImages] = useState(false); // State to track if all images should be shown

  useEffect(() => {
    const circle = {
      circle: id,
      organisation: myid
    };
    dispatch(adminInnerCircleDetailLoad(circle));
  }, [dispatch, id]);

  const { innerCircleDetails } = useSelector((state) => state.adminInnerReducer);

  const circleName = innerCircleDetails?.[0]?.name || appconstant.myInnerCircle;
  const circleMembers = innerCircleDetails?.[0]?.circleMembers || [];
  const description = innerCircleDetails?.[0]?.description || "no description";

  const remainingImagesCount = circleMembers.length > 3 ? circleMembers.length - 3 : 0;

  return (
    <div className='border border-royalPurple p-4 rounded-[10px] bg-white'>
      <div className='flex justify-between items-center mb-4'>
        <div className='text-2xl font-bold text-dark'>
          {circleName}
        </div>
        {/* <EllipsisOutlined /> */}
      </div>
      <div className='flex flex-wrap mb-8'>
        {showAllImages ? (
          // If showAllImages is true, show all images
          circleMembers.map((member, index) => (
            member.user?.avatar ? (
              <Tooltip key={index} title={member.user?.userName} placement='bottom'>
                <div className='m-1'>
                  <img src={`${SERVER_URL}${member.user.avatar}`} alt={`avatar-${index}`} className="w-[36px] h-[36px] object-contain" />
                </div>
              </Tooltip>
            ) : null
          ))
        ) : (
          circleMembers.slice(0, 3).map((member, index) => (
            member.user?.avatar ? (
              <Tooltip key={index} title={member.user?.userName} placement='bottom'>
                <div className='m-1'>
                  <img src={`${SERVER_URL}${member.user.avatar}`} alt={`avatar-${index}`} className="w-[36px] h-[36px] object-contain" />
                </div>
              </Tooltip>
            ) : null
          ))
        )}
        {showAllImages ? null : (
          // Render remaining count only if not showing all images
          remainingImagesCount > 0 && (
            <Tooltip title={`+${remainingImagesCount} more`} placement='bottom'>
              <div className='m-1 flex items-center justify-center bg-white text-dark border border-royalPurple w-[36px] h-[36px] font-xs p-4 rounded-full' onClick={() => setShowAllImages(!showAllImages)}>
                +{remainingImagesCount}
              </div>
            </Tooltip>
          )
        )}
      </div>
      <div className='text-sm font-normal break-words text-[#2F2F2FCC] mb-4'>
        {description}
      </div>
      {/* <ButtonLayout text="Create Activity" imgSrc={images.Add} onClick={handleNavigate} className="create-activity-btn" /> */}
    </div>
  );
}

export default InnerFeedCard;
